import { render, staticRenderFns } from "./HistoryTopUpWallet.vue?vue&type=template&id=229c757a&"
import script from "./HistoryTopUpWallet.vue?vue&type=script&lang=js&"
export * from "./HistoryTopUpWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports